import React, { useRef, MutableRefObject } from 'react';
import { Flex, FlexBehavior, FlexJustify, Tooltip } from 'react-magma-dom';
import { ModalButton } from '../Button';
import { Modal } from './Modal';
import { MarginWrapper, FontWeightWrapper, StyledSavedText, StyledEllipsisWrapper } from '../Styled';
import { COLORS } from '../../constants';
import { useTooltipForLongName } from '../../hooks/useLongNameTooltip';

interface IErrorModal {
  title?: string;
  mainColor: string;
  highlightColor: string;
  errorType: string;
  onRetryClick: () => void;
  onCloseClick: () => void;
}

export const ErrorModal: React.FC<IErrorModal> = (props): JSX.Element => {
  const { title, mainColor, highlightColor, errorType, onRetryClick, onCloseClick } = props;

  const ellipsisWrapperRef = useRef() as MutableRefObject<HTMLDivElement>;
  const styledTextNameRef = useRef() as MutableRefObject<HTMLSpanElement>;

  const isTooltip = useTooltipForLongName(ellipsisWrapperRef, styledTextNameRef);

  const showTitle = (withTooltip: boolean): JSX.Element => {
    const defaultTitleElement = (
      <StyledEllipsisWrapper ref={ellipsisWrapperRef} radius={2} width={333} behavior={FlexBehavior.item}>
        <StyledSavedText ref={styledTextNameRef} bgColor={highlightColor}>
          {title}
        </StyledSavedText>
        .
      </StyledEllipsisWrapper>
    );

    const tooltipStyle = {
      minWidth: 'fit-content',
    };

    return withTooltip ? (
      <Tooltip tooltipStyle={tooltipStyle} content={title}>
        {defaultTitleElement}
      </Tooltip>
    ) : (
      defaultTitleElement
    );
  };

  return (
    <Modal headerText="Oops! Error." headerColor={mainColor} onCloseClick={onCloseClick}>
      <Flex testId="error-modal-title" behavior={FlexBehavior.container} justify={FlexJustify.center}>
        <Flex behavior={FlexBehavior.item}>
          <span>
            An <FontWeightWrapper weight={800}>error</FontWeightWrapper> has occurred and we were unable to {errorType}
            &nbsp;
          </span>
        </Flex>
        {showTitle(isTooltip)}
      </Flex>
      <MarginWrapper margin="37px 0px 0px 0px">
        <ModalButton bGColor={mainColor} color={COLORS.white} text="Retry" onButtonClick={onRetryClick} />
      </MarginWrapper>
    </Modal>
  );
};
